import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminListArticles, adminDeleteArticle } from "@/lib/api";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export default function AdminArticles() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    adminListArticles().then((d) => { setItems(d); setLoading(false); });
  };

  useEffect(() => { load(); }, []);

  const remove = async (slug) => {
    if (!confirm(`Delete "${slug}"? This cannot be undone.`)) return;
    try {
      await adminDeleteArticle(slug);
      toast.success("Deleted");
      load();
    } catch { toast.error("Failed to delete"); }
  };

  return (
    <div data-testid="admin-articles">
      <div className="flex items-center justify-between flex-wrap gap-4 mb-10">
        <div>
          <div className="overline">Editorial</div>
          <h1 className="font-serif-editorial tight-track mt-4" style={{ fontSize: "clamp(2rem, 3.5vw, 3rem)", lineHeight: 1 }}>
            Articles
          </h1>
        </div>
        <Link to="/admin/articles/new" className="btn-olive" data-testid="new-article-btn">
          <Plus size={14} /> New article
        </Link>
      </div>

      {loading ? (
        <div className="opacity-60">Loading…</div>
      ) : (
        <div className="border-t" style={{ borderColor: "rgba(166,154,139,0.4)" }}>
          {items.length === 0 && <div className="py-10 opacity-60 font-serif-editorial text-xl">No articles yet.</div>}
          {items.map((a) => (
            <div key={a.slug} className="grid grid-cols-12 gap-4 items-center py-5 border-b" style={{ borderColor: "rgba(166,154,139,0.4)" }} data-testid={`admin-article-row-${a.slug}`}>
              <div className="col-span-12 md:col-span-6">
                <div className="font-serif-editorial text-xl">{a.title}</div>
                <div className="overline mt-1 opacity-80">/{a.slug}</div>
              </div>
              <div className="col-span-6 md:col-span-2 overline">{a.category}</div>
              <div className="col-span-6 md:col-span-2 text-xs opacity-70">
                {a.published ? "Published" : "Draft"}
              </div>
              <div className="col-span-12 md:col-span-2 flex gap-4 justify-start md:justify-end">
                <Link to={`/admin/articles/edit/${a.slug}`} className="overline editorial-link" data-testid={`edit-article-${a.slug}`}>Edit</Link>
                <button onClick={() => remove(a.slug)} className="overline editorial-link" data-testid={`delete-article-${a.slug}`} style={{ color: "#8a3a3a" }}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
